// type
import { TMatrix } from './types'
// utils
import { v4 as uuid } from 'uuid'

export const DEFAULT_MATRIX: TMatrix = {
  options: [],
  appetites: [],
  topSection: [
    [
      { id: uuid(), value: null },
      { id: uuid(), value: null }
    ]
  ],
  bLeftSection: [
    [
      { id: uuid(), value: null },
      { id: uuid(), value: null }
    ]
  ],
  bRightSection: [
    [
      { id: uuid(), value: null },
      { id: uuid(), value: null }
    ]
  ],
  selectedOption: null
}
